import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7977d702"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "outer"
}
const _hoisted_2 = { class: "guidance" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "initial-chat-outer" }
const _hoisted_5 = {
  key: 0,
  class: "grid"
}
const _hoisted_6 = ["onClick", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatInputText = _resolveComponent("ChatInputText")!

  return ($setup.noQuestionsAsked)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString($setup.welcomeMessage), 1),
          ($setup.view !== 'uat')
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Some common questions are shown below."))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ChatInputText),
          ($setup.view !== 'uat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.initialSuggestions, (suggestion, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "suggestions-container",
                    key: index
                  }, [
                    _createElementVNode("button", {
                      class: "button",
                      onClick: ($event: any) => ($setup.askQuestion(suggestion)),
                      value: suggestion
                    }, [
                      _createElementVNode("span", null, _toDisplayString(suggestion), 1)
                    ], 8, _hoisted_6)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}